
import posed, { PoseTransition } from 'vue-pose';

export default {
    data() {
        return {
          isShowing: false,
          currentIndex: 0,
        };
    },

    props: {
      imageData: {
        type: Array,
        default: function() {
          return [];
        },
      },
      startIndex: {
        type: Number,
        default: 0,
      },
    },

    computed: {
      currentImage: function(){
        return this.imageData[this.currentIndex];
      },
    },

    watch: {

    },

    methods: {
      didSelectPrevious: function(){
        if(!this.currentIndex) return;
        this.currentIndex--;
      },
      didSelectNext: function(){
        if(this.currentIndex+1 >= this.imageData.length) return;
        this.currentIndex++;
      },
      didSelectClose: function(){
        var self = this;

        self.isShowing = false;

        setTimeout(function() {
          self.$destroy();
        }, 500);

      },
    },

    components: {
      PoseTransition,
      Wrapper: posed.div({
        enter: {
          opacity: 1,
          beforeChildren: true,
          staggerChildren: 100,
          transition: {
            type: 'tween',
            ease: 'easeIn',
            duration: 250,
          },
        },
        exit: {
          opacity: 0,
          transition: {
            type: 'tween',
            ease: 'easeIn',
            duration: 250,
          },
        },
      }),
      GalleryBody: posed.div({
        enter: { opacity: 1, scale: 1, transition: { duration: 250, type: 'tween', ease: 'backOut' } },
        exit: { opacity: 0, scale: 0.5, transition: { duration: 250, type: 'tween', ease: 'backIn' } },
      }),
      GalleryImage: posed.div({
        enter: { opacity: 1, transition: { duration: 250, type: 'tween', ease: 'backOut' } },
        exit: { opacity: 0, transition: { duration: 250, type: 'tween', ease: 'backIn' } },
      }),
      GalleryToolbar: posed.div({
        enter: { opacity: 1, y: 0, transition: { delay: 250, duration: 350, type: 'tween', ease: 'backOut' } },
        exit: { opacity: 0, y: '-100%', transition: { duration: 250, type: 'tween', ease: 'backIn' } },
      }),
    },

    created() {

    },

    destroyed () {
      this.$el.parentNode.removeChild(this.$el);
    },

    mounted() {
      var self = this;

      if(self.startIndex && self.startIndex > 0) {
        self.currentIndex = self.startIndex;
      }

      setTimeout(function() {
        self.isShowing = true;
      }, 150);
    },
};




// WEBPACK FOOTER //
// ./scripts/vue/ImageLightbox.vue